import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AcceptInviteResponse, InvitePreview } from '@wrapforce/shared';
import { api } from '@/lib/api';

export function useAcceptInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (token: string) => api.post<AcceptInviteResponse>('/api/v1/invites/accept', { token }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['me'] }),
  });
}

export function useInvitePreview(token: string, enabled: boolean) {
  return useQuery({
    queryKey: ['invite-preview', token],
    queryFn: () => api.get<InvitePreview>(`/api/v1/invites/${token}`),
    enabled: enabled && !!token,
    retry: false,
  });
}
